import { ProductItemPreview } from 'components/Common';
import React, { FC, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import fetchRecentlyViewedProductPricesOperation from 'store/product/operation/fetchRecentlyViewedProductPricesOperation';
import { ProductItemPreviewProps } from 'store/product/types';
import gtmRecentlyViewedEvent from 'utils/gtm/gtmRecentlyViewedEvent';
import gtmSendEvent from 'utils/gtm/gtmSendEvent';
import recentlyViewedHelper from 'utils/recentlyViewedHelper';
import { Theme } from 'store/landing/types';
import ProductCarousel from '../ProductCarousel/ProductCarousel';

export interface RecentlyViewedBlockProps {
  theme?: Theme;
  forceRender?: number;
}

const RecentlyViewedBlock: FC<RecentlyViewedBlockProps> = ({ theme = 'default', forceRender }) => {
  const { t } = useTranslation();
  const [recentlyViewedItems, setRecentlyViewedItems] = useState<ProductItemPreviewProps[]>([]);
  const { getStored } = recentlyViewedHelper();
  const dispatch = useDispatch();

  async function fetchAndSetRecentlyViewed() {
    const stored = getStored();
    setRecentlyViewedItems(stored);

    if (stored.length === 0) {
      return;
    }

    dispatch(fetchRecentlyViewedProductPricesOperation(stored));
  }

  const onClickHandler = (product: ProductItemPreviewProps, url: string) => {
    gtmSendEvent(gtmRecentlyViewedEvent(product, url));
  };

  useEffect(() => {
    fetchAndSetRecentlyViewed();
  }, [forceRender]);

  return recentlyViewedItems.length > 0 ? (
    <div>
      <ProductCarousel progressBar theme={theme} title={t('txt_recently_viewed_items')}>
        {recentlyViewedItems.map((recentlyViewedItem) => (
          <ProductItemPreview
            key={recentlyViewedItem.uniqueProductId}
            showPrice
            usePriceFromProps={false}
            onClick={() => onClickHandler(recentlyViewedItem, recentlyViewedItem.productUrl || '')}
            productId={recentlyViewedItem.productId}
            categoryId={recentlyViewedItem.categoryId}
            productName={recentlyViewedItem.productName || ''}
            productThumbnail={recentlyViewedItem.productThumbnail}
            productUrl={recentlyViewedItem.productUrl || ''}
            theme={theme}
          />
        ))}
      </ProductCarousel>
    </div>
  ) : null;
};

export default RecentlyViewedBlock;
